/**
 * The Scientist — original stylised portrait (SVG). Wild swept-back silver hair, brass
 * goggles pushed up on the forehead, one portal-green goggle lens, lab coat with a pen.
 * Parts carry classes the CSS animates per mood: .brow.l/.r, .eye, .lid, .blinker, .jaw.
 */
export const PORTRAIT_SVG = `<svg viewBox="0 0 64 64" aria-hidden="true">
  <defs>
    <radialGradient id="pskin" cx="45%" cy="40%" r="60%"><stop offset="0" stop-color="#f3dccb"/><stop offset="1" stop-color="#cfa792"/></radialGradient>
    <linearGradient id="phair" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f4f7ff"/><stop offset="1" stop-color="#9fb0c8"/></linearGradient>
    <radialGradient id="plens" cx="40%" cy="35%" r="60%"><stop offset="0" stop-color="#e6ffd0"/><stop offset=".5" stop-color="#97ff5a"/><stop offset="1" stop-color="#2d7a1c"/></radialGradient>
  </defs>
  <!-- coat -->
  <path d="M6 64c2-11 10-16 26-16s24 5 26 16z" fill="#e9f1ee"/>
  <path d="M24 49l8 9 8-9-3-2-5 5-5-5z" fill="#2b3b36"/>
  <path d="M20 50l6 14h-4l-6-12z M44 50l-6 14h4l6-12z" fill="#c9d6d1"/>
  <rect x="44" y="53" width="2" height="8" rx="1" fill="#97ff5a"/>
  <!-- neck + head -->
  <path d="M27 42h10v8H27z" fill="#cfa792"/>
  <ellipse cx="32" cy="30" rx="13" ry="15" fill="url(#pskin)"/>
  <ellipse cx="19.5" cy="31" rx="2.4" ry="3.6" fill="#cfa792"/>
  <ellipse cx="44.5" cy="31" rx="2.4" ry="3.6" fill="#cfa792"/>
  <!-- hair: swept back flames -->
  <path d="M17 26c-4-6-3-12 1-15-1 4 1 5 3 5-2-5 1-10 6-12-1 3 0 5 3 5 0-4 4-7 8-7-2 2-2 4 0 5 3-2 8-1 10 2-3 0-4 1-4 3 4-1 7 2 8 5-3-1-5 0-5 2 2 1 3 4 2 7-2-2-4-3-6-2 0-5-5-9-12-9s-12 4-12 10c-1-1-1 0-2 1z" fill="url(#phair)"/>
  <!-- goggles on forehead -->
  <path d="M19 19.5c8-3 18-3 26 0" stroke="#5a3d22" stroke-width="2.4" fill="none"/>
  <circle cx="26" cy="18.5" r="4.2" fill="#8a6a3a" stroke="#3b2a15" stroke-width="1"/>
  <circle cx="26" cy="18.5" r="2.8" fill="url(#plens)" class="lens"/>
  <circle cx="38" cy="18.5" r="4.2" fill="#8a6a3a" stroke="#3b2a15" stroke-width="1"/>
  <circle cx="38" cy="18.5" r="2.8" fill="#2c3440"/>
  <circle cx="25" cy="17.4" r=".9" fill="#fff"/>
  <!-- brows -->
  <path class="brow l" d="M22.5 25.5l7-1.2" stroke="#7e8ea6" stroke-width="2.2" stroke-linecap="round"/>
  <path class="brow r" d="M34.5 24.3l7 1.2" stroke="#7e8ea6" stroke-width="2.2" stroke-linecap="round"/>
  <!-- eyes -->
  <g class="eye" style="transform-origin:26.5px 29.5px"><ellipse cx="26.5" cy="29.5" rx="3" ry="3.2" fill="#fff"/><circle cx="27" cy="29.8" r="1.6" fill="#1d2a2a"/></g>
  <g class="eye" style="transform-origin:37.5px 29.5px"><ellipse cx="37.5" cy="29.5" rx="3" ry="3.2" fill="#fff"/><circle cx="38" cy="29.8" r="1.6" fill="#1d2a2a"/></g>
  <path class="lid" d="M23.3 29.3a3.2 3.2 0 0 1 6.4 0zM34.3 29.3a3.2 3.2 0 0 1 6.4 0z" fill="#d8b49f"/>
  <path class="blinker" d="M23.2 29.6a3.3 3.4 0 0 0 6.6 0a3.3 3.4 0 0 0-6.6 0zM34.2 29.6a3.3 3.4 0 0 0 6.6 0a3.3 3.4 0 0 0-6.6 0z" fill="#d8b49f"/>
  <!-- nose -->
  <path d="M32 30.5c-1 3-2.2 5-1 6 .8.5 2 .4 2.6 0" stroke="#b38670" stroke-width="1.3" fill="none" stroke-linecap="round"/>
  <!-- stubble + mouth -->
  <path d="M22 38c3 6 17 6 20 0" fill="#b9a49a" opacity=".35"/>
  <path d="M27 39.2c3 1 7 1 10 0" stroke="#6b3a34" stroke-width="1.4" fill="none" stroke-linecap="round" class="mouth"/>
  <ellipse class="jaw" cx="32" cy="40" rx="3.6" ry=".6" fill="#4a1f1c"/>
</svg><div class="burp"></div>`;
